export default function style(set) {
  return { wrapperWidthReady: false, headerHeight: 60 };
}
